// extracted by mini-css-extract-plugin
export var lightMode = "_1t-0";